/* The skill library: each entry is a real pattern TeamGrid found, the skill it
   built from that pattern, and the runs that skill has performed since. */
export const ERA_SKILLS = [
  {
    id: 'meeting-load',
    name: 'Meeting Load Guard',
    c: '#F2A73A',
    status: 'ACTIVE',
    team: 'Ops',
    what: 'Watches meeting share per team and protects maker time before the week fills up.',
    src: 'CALENDAR · OPS',
    pattern: 'Ops spent <b>41% of last week</b> in meetings — 2× the company baseline, and rising for 3 weeks straight.',
    evidence: ['18 recurring invites', '2× baseline', '3-week trend'],
    runs: [
      { t: 'Mon 07:02', do: 'Trimmed 2 standing calls from 12 calendars', r: '2.5h/week back' },
      { t: 'Wed 07:02', do: 'Blocked Wed 9–12 as company focus time', r: '+14% deep focus' },
      { t: 'Fri 16:30', do: 'Flagged 3 invites with no agenda', r: '3 declined' },
    ],
  },
  {
    id: 'reply-sla',
    name: 'Reply SLA Keeper',
    c: '#366EB6',
    status: 'ACTIVE',
    team: 'Sales',
    what: 'Tracks how long client mail waits per owner and escalates before a deal goes cold.',
    src: 'EMAIL · SALES',
    pattern: '<b>42 client emails</b> had waited 48h+ for a reply, concentrated on 4 owners.',
    evidence: ['42 threads', '48h+ idle', '4 owners'],
    runs: [
      { t: 'Today 09:14', do: 'Nudged 4 owners with their oldest threads', r: 'queue cleared' },
      { t: 'Yesterday', do: 'Re-routed 7 threads from an owner on leave', r: 'no thread >12h' },
      { t: 'Mon 08:00', do: 'Raised 2 accounts to the AE lead', r: 'reply time −67%' },
    ],
  },
  {
    id: 'burnout',
    name: 'Burnout Early-Warning',
    c: '#F2673A',
    status: 'ACTIVE',
    team: 'Marketing',
    what: 'Compares each person to their own rhythm — never to their teammates — and raises a quiet flag.',
    src: 'ACTIVITY · MARKETING',
    pattern: 'After-hours work ran at <b>3× personal baseline</b> for 2 weeks across 5 people.',
    evidence: ['5 people', '3× baseline', '14 days'],
    runs: [
      { t: 'Mon 08:30', do: 'Raised a private check-in for 2 managers', r: '2 conversations' },
      { t: 'Tue 11:05', do: 'Rebalanced 6 tasks off the two heaviest loads', r: 'after-hours −38%' },
    ],
  },
  {
    id: 'load-balance',
    name: 'Load Balancer',
    c: '#8B75D7',
    status: 'ACTIVE',
    team: 'Delivery',
    what: 'Matches real capacity to project demand every morning, before standup.',
    src: 'PROJECTS · DELIVERY',
    pattern: '<b>3 people carried 70%</b> of Green Soul while 4 teammates sat under 40% utilised.',
    evidence: ['70% on 3 people', '4 under-used', '1 project at risk'],
    runs: [
      { t: 'Today 07:45', do: 'Reassigned 2 tasks to Dev and Sarah', r: 'load 70% → 48%' },
      { t: 'Mon 07:45', do: 'Warned on Green Soul delivery risk', r: 'date held' },
    ],
  },
  {
    id: 'lead-routing',
    name: 'Lead Routing Skill',
    c: '#2DBDB8',
    status: 'LEARNING',
    team: 'Pipeline',
    what: 'Routes each new lead to the first free rep the moment it lands, using live capacity.',
    src: 'CRM · PIPELINE',
    pattern: 'New leads sat <b>6 hours</b> on average before anyone logged them.',
    evidence: ['6h to first touch', '31% after hours', '12 leads/day'],
    runs: [
      { t: 'Today 10:22', do: 'Routed 12 leads by live rep capacity', r: 'first touch −98%' },
      { t: 'Learning', do: 'Sampling weekend and after-hours volume', r: '3 days left' },
    ],
  },
  {
    id: 'focus-protect',
    name: 'Focus Protector',
    c: '#34A851',
    status: 'SUGGESTED',
    team: 'Engineering',
    what: 'Learns which rituals cost more focus than they return, then proposes dropping them.',
    src: 'FOCUS · ENGINEERING',
    pattern: 'Deep focus climbed <b>14%</b> on the days engineering skipped standup.',
    evidence: ['+14% focus', '6 weeks of data', '2 rituals'],
    runs: [
      { t: 'Proposed', do: 'Make no-meeting Wednesday company-wide', r: 'awaiting approval' },
    ],
  },
];
